// extracted by mini-css-extract-plugin
export default {"gamesPage":"Games_gamesPage__yWmIS"};